import { Box, BoxProps, SxProps, Theme } from '@mui/material';

import { appCardMediaSx } from './app-card-styles';

/**
 * Top slot for card media (image, video preview, waveform, etc.).
 * Uses a full-width flex-shrink-0 container so media does not compress the body.
 */
export function AppCardMedia({ sx, children, ...props }: BoxProps) {
  return (
    <Box
      {...props}
      sx={
        [
          appCardMediaSx,
          ...(sx !== undefined ? (Array.isArray(sx) ? sx : [sx]) : []),
        ] as SxProps<Theme>
      }
    >
      {children}
    </Box>
  );
}
